<template>
  <div class="hello">
    <h1>Create quiz</h1>
    fetch list of shows
      <b-dropdown text="Select a show">
    <div v-for="a in entities" :key="a.id">
    <b-dropdown-item href="#">{{a.title}} -
        <button type="button" @click="setEntity(a)" class="btn btn-sm btn-info">set</button>
    </b-dropdown-item>
    </div>
  </b-dropdown>
  <hr/>
  
  <div v-if="selectedShow">
    <h3>{{selectedShow.title}}</h3>
    <div v-if="!quizAdded">
        <button class="btn btn-primary" @click="addQuiz(selectedShow)">Add Quiz</button>
    </div>
    <div v-if="quizAdded" class="col-sm-6 container">

        let's created some questions for {{selectedShow.title}}<br/>
        {{questions}}

        <form @submit.prevent="addQuestion(questions,choices)">
        <input class="form-control" id="choiceB" v-model="questions" placeholder="Enter Question">
        <h3>Choices</h3>
        <input class="form-control" id="choiceB" v-model="choices.choice1" placeholder="Enter Question">
        <input class="form-control" id="choiceB" v-model="choices.choice2" placeholder="Enter Question">
        <input class="form-control" id="choiceB" v-model="choices.choice3" placeholder="Enter Question">
        <input class="form-control" id="choiceB" v-model="choices.choice4" placeholder="Enter Question">
        <input type="submit" class="btn btn-success" value="Submit Question"/>
        </form>
        <hr/>
        <div v-for="q in submitted" :key="q.id">
            <input class="form-control" :value="q.question"/>
            Choices<br/>
            <div v-for="c in q.choices" :key="c.id">
            <input class="form-control" :value="c.text" />
            <button class="btn btn-sm btn-danger" @click="setAnswer(q.id,c)">Correct {{c.text}}</button>
            </div><button type="button" class="btn btn-info" @click="getAnswer(q.id)">
                Show Answer </button>{{showAnswer }}
             <hr/>
            </div>
            
    </div>
  </div>
  </div>
</template>

<script>
import db from '../../../../lib/db'
export default {
  name: 'CreateQuiz',
  props: {
    msg: String
  },
  data () {
      return {
          entities: "",
          selectedShow: null,
          questions: "", 
          choices: {
              choice1: "",
              choice2: "",
              choice3: "",
              choice4: ""
              },
            submitted: [],
            correctAnswer: {l:'lj'}
      }
  },
  methods: {
      getEntity: function () {
        return db.getRef().ref(this.$route.params.entity).once('value')
        .then((snapshot)=> {
            console.log('fetched ', snapshot.val())
            this.entities = snapshot.val()
        })
      },
      setEntity: function (entity) {
          console.log('selected ', entity)
          this.selectedShow = entity
          this.getQuizQuestions()
      },
      addQuestion: function (q,c){
          console.log('the qu ', q)
        let quizRef = db.getRef().ref('quizquestions').child(this.selectedShow.quizid)
        .child('questions')
            quizRef.push().then((ref)=>{
                console.log('the quiz rer ', quizRef)
                quizRef.child(ref.key).update({
                    question: q,
                    id:ref.key})
                return ref.key
            }).then((key) => {
                console.log('the forgotten key ;, ', key)
                let choicekey = quizRef.child(key)
                for (let obj in c) {
                    
                    if (c.hasOwnProperty(obj)) {
                        choicekey.push().then((nkey)=>{
                            choicekey.child('choices/'+nkey.key).update({
                                id: nkey.key,
                                text: c[obj]})
                        })
                        console.log(obj + " -> " + c[obj]);
                        //need to set the correct answer and store it
                        //reset question and choicevalues
                    }
                    }
          this.getQuizQuestions().then(()=>{
              this.choices = this.questions = ''
          })

            })

      },
      setAnswer: function (q,a) {
        let ansRef = db.getRef().ref('quizanswers/'+
        this.selectedShow.quizid+'/'+q)
        ansRef.set(a).then(()=>{
            this.getAnswer(q)
        })
      },
      getAnswer: function (q) {
          db.getRef().ref('quizanswers/'+this.selectedShow.quizid+'/'+q)
          .once('value').then((snapshot) => {
              console.log('the answer ', snapshot.val())
              this.correctAnswer  = snapshot.val()

          })
      },
      addQuiz: function(entity){
        console.log('create a quiz for ', entity)
        return db.getRef().ref('quizquestions').push({show: entity.id})
        .then((ref)=> {
            db.getRef().ref(this.$route.params.entity+'/'+entity.id)
            .update({quizid: ref.key})
            return ref.key
        }).then((key)=>{
            this.selectedShow.quizid = key
            console.log('k from lat promist ', this.selectedShow.quizid)
        })
      },
      getQuizQuestions: function(){
          return db.getRef().ref('quizquestions/'+this.selectedShow.quizid).once('value')
          .then((snapshot) => {
              this.submitted = snapshot.child('questions').val()
          })
      }
  },
  computed: {
      quizAdded: function() {
          return this.selectedShow.quizid
      },
      submittedQuestions: function () {
          return this.submitted
      },
      showAnswer: function () {
          return this.correctAnswer
      }
  },
  created () {
      this.getEntity()
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
